export default function humanTimeHelper(time, dataOnly) {
  if (dataOnly === void 0) {
    dataOnly = true;
  }
  const d = dayjs(time);
  const humanTime = window.katerCore.humanTime;
  const datetime = d.format();
  const full = d.format('LLLL');
  const ago = humanTime(time, dataOnly);
  return m("time", {
    pubdate: true,
    datetime: datetime,
    title: full,
    "data-humantime": true
  }, ago);
}
flarum.reg.add('ziiven-ziven-core', 'common/helpers/humanTimeHelper', humanTimeHelper);